import React from 'react';
import ReactGA from 'react-ga';
import imgUrl from '../../assets/gie-logo-bg-3.jpg';
import MyCoordinateFormDetail from '../../components/form/MyCoordinateFormDetail';
import DownloadPdf from './DownloadPdf';
import BankFormDetail from './BankFormDetail';
import WebEventController from '../../controller/web-event.controller';
import {WebEventUtil} from '../../util/web-event-util';
import GIEServicesContainer from "../../components/GIEServicesContainer/GIEServicesContainer";
import TitleListScreen from "../../components/TitleListeScreen/TitleListScreen";
import GieCard from "../../components/GIECard/GieCard";
import HeaderForm from "../../components/form/HeaderForm";
import NoticeForList from "../../components/GIEList/NoticeForList";

export default class BankForm extends React.Component<any, any> {
  webEventController: WebEventController = new WebEventController();

  constructor(props: any) {
    super(props);
    this.state = {
      dataSend: false,
      bic: '',
      iban: '',
      coordinates: {bic: '', iban: ''},
      step: 0
    }
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  changeForm = (form) => {
    this.setState({dataSend: true})
  }

  next = () => {
    this.setState({step: this.state.step + 1})
  }

  previous = () => {
    this.setState({step: this.state.step - 1})
  }

  changePersonnalCoordinate = (coordinatesData) => {
    let coordinate = {};
    Object.keys(coordinatesData).forEach((name, key) => {
      coordinate[name] = coordinatesData[name].value
    });
    this.setState({coordinate})
    this.next();
  }

  changeBankCoordinates = (event) => {
    let coordinate = this.state.coordinate;
    coordinate.bic = event.bic.value;
    coordinate.iban = event.iban.value;
    this.setState({coordinate});
    const noContract = coordinate.noContract;
    if (!noContract?.length) {
      window.location.href = "/admin/login"
    } else {
      const request = {
        noContrat: noContract,
        eventType: "3",
        eventCode: 'CHGBANK',
        description: 'Souscrire au prélèvement automatique',
        confirm: '0',
        mail_object: WebEventUtil.getBodyOfEmail(coordinate),
        noClient: null,
        codeSite: null
      }
      this.webEventController.insertWebEvent(request).then(data => {
        this.next();
      }).catch(err => {
        console.log(err)
      })
    }
  }

  render() {
    return (
      <div className="content">
        <GIEServicesContainer imgUrl={imgUrl} title={<TitleListScreen miniTitle="Souscrire au prélèvement automatique"
                                                                      href="coordonnées-bancaires"
                                                                      title="Transmettez-nous votre demande"/>}>

          <div className="container-xl mb-5">
            <NoticeForList className="mb-3"
                           text="Le prélèvement automatique sera effectué une fois par an et correspondra au montant total annuel du contrat d’entretien."/>

            <GieCard width="100%" height="100%">
              {this.state.step < 3 && <HeaderForm step={this.state.step}
                                                  first="1 - Vos coordonnées"
                                                  second="2 - Vos coordonnées bancaires"
                                                  third="3 - Votre mandat de prélèvement"/>}
              {this.state.step === 0 && <MyCoordinateFormDetail emit={this.changePersonnalCoordinate}
                                                                withButton
                                                                buttonText="Suivant"/>}
              {this.state.step === 1 && <BankFormDetail previous={this.previous}
                                                        emit={this.changeBankCoordinates}/>}
              {this.state.step === 2 && <DownloadPdf/>}
            </GieCard>
          </div>
        </GIEServicesContainer>
      </div>
    );
  }
}
